<script>
export default {
    name: 'TabItem',

    functional: true,

    props: {
        action: {type: String, required: true},
        active: {type: Boolean},
    },

    render(createElement, {props, children}) {
        return createElement('li', {staticClass: 'nav-item'}, [
            createElement('a', {
                staticClass: 'nav-link',
                class: props.active ? 'active' : '',
                attrs: {'href': props.action},
            }, children),
        ]);
    },
};
</script>
